/* ===========================================================================
   YOU CANNOT PRE-ORDER MORE THAN WE HAVE ALLOCATED.

   Sharon, 9 September 2026: three Solstice corners on sale, nothing preventing
   an order for thirty. Every pre-order variant is CONTINUE — which is the only
   reason it can be bought at zero stock — and CONTINUE never stops. The service
   has always computed `remaining`; nothing on the storefront ever read it.

   IT CORRECTS, IT DOES NOT INTERCEPT.

   The obvious implementation wraps window.fetch and blocks an over-quantity
   before it reaches Shopify. This does not do that, on purpose. rn-pdp-cart.js
   already wraps fetch, add-to-cart is the one path on this store that must never
   break, and a guard that throws would take the whole shop down while looking
   like a stock problem. A blocked sale is worse than the problem being fixed.

   So: after any cart change, read the cart, and if a line exceeds what is
   allocated, set it back down and say so. The cart cannot hold an over-quantity
   for longer than one round trip, and every failure mode here leaves the
   customer able to buy.

   FAIL OPEN, EVERYWHERE. No caps, bad data, a fetch that rejects, the cart
   endpoint moving — every branch ends with the customer still able to check out.

   THIS IS NOT THE LAST LINE OF DEFENCE and must not be mistaken for one. Anyone
   with a console can post whatever they like. Two things sit behind it: the
   service flips an exhausted variant to DENY within 15 minutes, so Shopify
   itself refuses; and a Shopify Function validating the cart at checkout is the
   only thing that cannot be bypassed at all. This closes the accident, which is
   what actually happens.
   =========================================================================== */
(function () {
  'use strict';

  var CAP = window.RN_PO_CAP;
  if (!CAP || typeof CAP !== 'object') return;

  var caps = {};
  var any = false;
  for (var k in CAP) {
    if (!Object.prototype.hasOwnProperty.call(CAP, k)) continue;
    var n = parseInt(CAP[k], 10);
    /* A cap of zero would mean "in the cart but nothing allocated". Shopify's
       own DENY policy handles that; clamping to zero here would silently empty
       someone's basket, which is not ours to do. */
    if (isFinite(n) && n > 0) { caps[String(k)] = n; any = true; }
  }
  if (!any) return;

  var busy = false;
  var lastNotice = 0;

  function notice(text) {
    try {
      /* One line, in the page's own voice, near the cart. Deliberately plain:
         this is a limit, not an error, and the customer has done nothing wrong. */
      if (Date.now() - lastNotice < 1500) return;
      lastNotice = Date.now();

      var el = document.getElementById('rn-po-cap-note');
      if (!el) {
        el = document.createElement('div');
        el.id = 'rn-po-cap-note';
        el.setAttribute('role', 'status');
        el.style.cssText =
          'position:fixed;left:50%;transform:translateX(-50%);bottom:24px;z-index:99999;' +
          'max-width:min(460px,92vw);padding:12px 16px;border-radius:6px;' +
          'background:#1A1712;color:#FAF8F4;font-size:14px;line-height:1.4;' +
          'box-shadow:0 10px 30px rgba(26,23,18,.28);opacity:0;transition:opacity .2s ease';
        document.body.appendChild(el);
      }
      el.textContent = text;
      requestAnimationFrame(function () { el.style.opacity = '1'; });
      clearTimeout(el.__t);
      el.__t = setTimeout(function () { el.style.opacity = '0'; }, 5200);
    } catch (e) { /* a missing message must never stop the correction */ }
  }

  function plural(n) { return n === 1 ? '' : 's'; }

  /* Read the cart, clamp anything over its cap, one line at a time.
     Sequential rather than parallel: /cart/change.js rewrites the whole cart and
     concurrent changes overwrite each other's line keys. */
  function check() {
    if (busy) return;
    busy = true;

    window.fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return null;

        var over = [];
        for (var i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          var cap = caps[String(it.variant_id)];
          if (cap && it.quantity > cap) over.push({ key: it.key, cap: cap, was: it.quantity, title: it.product_title });
        }
        if (!over.length) return null;

        /* Chain them so each change sees the cart the previous one left. */
        var chain = Promise.resolve();
        over.forEach(function (o) {
          chain = chain.then(function () {
            return window.fetch('/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: o.key, quantity: o.cap })
            });
          });
        });
        return chain.then(function () { return over; });
      })
      .then(function (over) {
        if (!over || !over.length) return;
        var o = over[0];
        notice(over.length === 1
          ? 'We have ' + o.cap + ' ' + o.title + ' left on this shipment, so your cart has been set to ' + o.cap + '.'
          : over.length + ' items were reduced to the quantity still available on their shipment.');

        /* Let the theme redraw its own drawer. It listens for this already. */
        try { document.dispatchEvent(new CustomEvent('cart:update', { detail: { source: 'rn-po-cap' } })); } catch (e) {}
      })
      .catch(function () { /* fail open: leave the cart exactly as the customer left it */ })
      .then(function () { busy = false; });
  }

  /* Visible steppers get a max, so the common path never even reaches a
     correction. Belt and braces — the correction above is what guarantees it. */
  function clampInputs() {
    try {
      var inputs = document.querySelectorAll('input[type="number"][name="quantity"], input[type="number"][data-quantity]');
      for (var i = 0; i < inputs.length; i++) {
        var row = inputs[i].closest('[data-variant-id]');
        var id = row && row.getAttribute('data-variant-id');
        var cap = id && caps[String(id)];
        if (cap) inputs[i].max = String(cap);
      }
    } catch (e) {}
  }

  function run() { clampInputs(); check(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  /* Every route that changes a cart on this store ends in one of these. */
  document.addEventListener('cart:update', function (e) {
    if (e && e.detail && e.detail.source === 'rn-po-cap') return;   /* our own echo */
    setTimeout(run, 120);
  });
  document.addEventListener('cart:refresh', function () { setTimeout(run, 120); });
  document.addEventListener('shopify:section:load', function () { setTimeout(run, 120); });
})();
